import React, { Component } from 'react';
import { Theme } from '../../theme/theme';
import { Drawer, Avatar, FloatingActionButton } from 'material-ui';
import defaultProfileImage from '../../public/default_profile.png';
import { FontAwesome } from '../../common/components/font-awesome';
import { MENU_ITEMS } from '../menu-items';
import { NavLink, RouteComponentProps } from 'react-router-dom';
import logo from '../../public/dualiti.png';
import { logout } from '../../account/account.util';
import { ChildProps } from 'react-apollo';
import { GetUserQuery } from '../../ApolloComponents';

const SIDEBAR_WIDTH = 256;

type Props = ChildProps<RouteComponentProps<{}>, GetUserQuery>;

export class AppDrawerView extends Component<Props> {
  render() {
    const { data } = this.props;

    if (!data || data.loading || !data.getUser) {
      return null;
    }

    const { getUser: user } = data;

    return (
      <Drawer
        width={SIDEBAR_WIDTH}
        containerStyle={{
          backgroundColor: Theme.PRIMARY_COLOR,
          color: '#ffffff',
        }}
        docked={true}
        open={true}
      >
        <div
          style={{
            backgroundColor: Theme.SECONDARY_COLOR,
            padding: '16px 20px',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            minHeight: 64,
            boxSizing: 'border-box',
          }}
        >
          <Avatar
            src={user.profilePictureUrl || defaultProfileImage}
            size={40}
            style={{ flexShrink: 0 }}
          />
          <div
            style={{
              color: '#1a1a1a',
              fontSize: 15,
              fontWeight: 600,
              lineHeight: 1.3,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {user.name}
          </div>
        </div>

        <nav
          style={{
            flex: 1,
            overflowY: 'auto',
            padding: '12px 0',
          }}
        >
          {MENU_ITEMS.map((menuItem) => (
            <NavLink
              key={menuItem.link}
              to={menuItem.link}
              className={({ isActive }) =>
                isActive ? 'sidebar-nav-link active' : 'sidebar-nav-link'
              }
            >
              <FontAwesome name={menuItem.iconName} className="sidebar-nav-icon" />
              <span>{menuItem.title}</span>
            </NavLink>
          ))}
        </nav>

        <div
          style={{
            padding: '20px 16px 24px',
            textAlign: 'center',
            borderTop: '1px solid rgba(255, 255, 255, 0.12)',
          }}
        >
          <FloatingActionButton
            onClick={() => logout()}
            onTouchTap={() => logout()}
            style={{ backgroundColor: Theme.ACTIVE2_COLOR }}
            mini
          >
            <FontAwesome name="sign-out" />
          </FloatingActionButton>
          <div
            style={{
              marginTop: 16,
              color: 'rgba(255, 255, 255, 0.7)',
              fontSize: 11,
              lineHeight: 1.5,
            }}
          >
            Powered by Dualiti LLC
            <br />
            <img
              alt="Dualiti LLC"
              style={{ width: 72, marginTop: 8, objectFit: 'contain', opacity: 0.9 }}
              src={logo}
            />
          </div>
        </div>
      </Drawer>
    );
  }
}
